import { render, staticRenderFns } from "./SelectRichText.vue?vue&type=template&id=659918cc&scoped=true&"
import script from "./SelectRichText.vue?vue&type=script&lang=js&"
export * from "./SelectRichText.vue?vue&type=script&lang=js&"
import style0 from "./SelectRichText.vue?vue&type=style&index=0&id=659918cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659918cc",
  null
  
)

export default component.exports